<template>
  <div class="bg-white w-full h-full">
    <apollo-query
            :query='getPostActivityQuery'
            class='flex flex-row h-full'
            fetch-policy='cache-and-network'
            :variables='{from:0,size:100}'>
        <template v-slot="{ result: { error, data }, isLoading, query }">
          <loading v-if='isLoading' />

          <div v-if='!isLoading && data' class="grow flex flex-col h-full">
            <div class="overflow-scroll" style='flex: 1; max-height:600px'>
              <table class="text-left m-4 md:w-full overflow-scroll" style="border-collapse:collapse text-xs">
                <thead>
                  <tr>
                    <th class="table-header">View</th>
                    <th class="table-header">Data</th>
                    <th class="table-header">Created</th>
                    <th class="table-header">Updated</th>
                    <th class="table-header">deviceid</th>
                    <th class="table-header">Size</th>
                    <th class="table-header">Title</th>
                    <th class="table-header">Who</th>
                  </tr>
                </thead>
                <tbody>

                  <tr v-for='activity in data.getPostActivity.items' :key='activity.id' class="table-row" :class='isSelected(activity)'>
                    <td class="table-col">
                      <pbc-button @click='edit(activity)'>
                        <play class="mx-2" />
                      </pbc-button>
                    </td>
                    <td class="table-col">
                      <a class="pbc-button" target="_blank" :href='makeEditUrl(activity)'>
                        <table-of-contents class="mx-2" />
                      </a>
                    </td>


                    <td class="table-col">{{activity.created}}</td>
                    <td class="table-col">{{activity.updated}}</td>
                    <td class="table-col">{{activity.deviceid}}</td>
                    <td class="table-col">{{activity.size}}</td>
                    <td class="table-col">{{activity.title}}</td>
                    <td class="table-col"><user :user='activity.author' /></td>
                  </tr>
                </tbody>

              </table>

            </div>
            <editor v-if='showing && editingGamedata.id'
                  style='flex: 4'
                  :gamedata='editingGamedata'
                  :key='editingGamedata.id'
                  :transforms-and-source='defaultScene' />
            <pbc-button @click='onPostActivity(editingGamedata)'>Recover</pbc-button>
                  
          </div>

        </template>
    </apollo-query>

  </div>
</template>
<script>
const LONG_PATTERN = "yyyy-MM-dd'T'HH:mm:ss";
import { addMinutes, format } from 'date-fns'
import TableOfContents from '@icons/TableOfContents.vue';
import Play from '@icons/Play.vue';
import User from '@ui/atoms/User.vue';
import { sortBy } from 'lodash';
import { parseISO, formatISO } from 'date-fns';
import ComponentLazyLoader from '@/lazyloader.js';
const {componentLoadingState, fn:Editor}  = ComponentLazyLoader(() => import(/* webpackChunkName: "edit" */ '@/edit/organisms/Editor.vue'));
import { ApolloQuery } from 'vue-apollo'
import gql from 'graphql-tag';
import Gamedata from '@edit/tree/gamedata.js';
import { savePostDraftQuery } from '@/gql/Queries.js';

const getPostActivityQuery = gql(`
query getPostActivity($from: Int, $size: Int) {
  getPostActivity(from: $from, size: $size) {
    items {
      id
      updated
      created
      title
      deviceid
      author {
        id
        username
      }
      size
    }
  }
}
`)
export default {
  inject:['api'],
  components: {
    Editor,
    User,
    TableOfContents,
    Play
  },
  data() {
    const id = this.$route.params.id;
    return {
      id,
      showing:true,
      getPostActivityQuery,
      editingGamedata:{},
      editingActivity:''
    }
  },
  methods:{
    async onPostActivity(gamedata) {
      console.log(':-(((((((((((((((((');
      const now = format(this.getUTCDate(), LONG_PATTERN);
      await this.$apollo.mutate({
        mutation:savePostDraftQuery,
        client:'localClient',
        //mutation:addItemQuery,
        fetchPolicy:'no-cache',
        variables:{
          id: gamedata.id,
          created: now,
          updated: now,
          title: 'Recovered from autosave',
          gamedata: JSON.stringify(gamedata),
          parentId: 'root',
          opId: 'root'
        }
      });

      alert('recovered to draft');

    },
    async edit(activity) {
      this.showing = false;
      this.editingActivity = activity.id;
      await this.readFile(activity.id);
      setTimeout( () => {
        this.showing = true;
      }, 500);
    },
    isSelected(activity) {
      return activity.id === this.editingActivity ? 'activity-selected' : '';
    },
    async readFile(id) {
      const data = await fetch(this.api.makeActivityUrl(id))
      const gamedata = await data.json();
      console.log('data', gamedata);
      this.editingGamedata = gamedata;
    },
    makeEditUrl(activity) {
      return `http://34.249.0.97:3000/dashboard/557?category=${activity.deviceid}`
    },
    getUTCDate() {
      const date = new Date();
      return addMinutes(date, 0);
    },
  },
  computed:{
    defaultScene() {
      const gamedata = new Gamedata(this.editingGamedata);
      const transformsAndSource = gamedata.getSceneByIndex(0);
      return transformsAndSource;
    }

  },
  watch:{
    gamedata() {
    }
  }
}
</script>
<style lang="scss">
.table-header {
@apply py-4 px-6 bg-gray-100 font-sans font-medium uppercase text-sm text-gray-600 border-b border-gray-200 ;
}
.table-row {
}
.table-row:hover {
  @apply bg-blue-100;
}
.table-col {
  @apply text-xs py-1 px-6 border-b border-gray-300;
}
.activity-selected {
  @apply border-2 border-blue-200 border-solid;
}
</style>
